var _title, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerDeparture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007efc",
    d: "m23.49367,0.03503c-9.27001,0 -16.7848,7.516 -16.7848,16.7848c0,9.27001 16.7848,31.17178 16.7848,31.17178s16.7848,-21.90177 16.7848,-31.17178c0,-9.26881 -7.5148,-16.7848 -16.7848,-16.7848z",
    id: "svg_1",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    fill: "white",
    id: "svg_3",
    d: "m18.11311,4.16785c-0.11267,0.00347 -0.22694,0.02078 -0.33768,0.05423c-0.80261,0.24356 -1.17067,1.17099 -0.75422,1.89788l4.23202,7.38199l-6.42812,1.69576l-1.87323,-1.57499c-0.25618,-0.2158 -0.60375,-0.28696 -0.92429,-0.18979c-0.61584,0.18425 -0.89741,0.89896 -0.57182,1.45422l1.62675,2.77532c0.57293,0.97676 1.72431,1.45357 2.81969,1.16584l18.58191,-4.89503a1.89294,1.89294 0 0 0 0.0074,-0.00247a1.89294,1.89294 0 0 0 1.56514,-1.86336a1.89294,1.89294 0 0 0 -1.89294,-1.89294a1.89294,1.89294 0 0 0 -0.48803,0.06408l0,-0.00246l-6.60066,1.73766l-8.03516,-7.45839c-0.2546,-0.23662 -0.58874,-0.35796 -0.92675,-0.34754zm-5.27461,18.62628c-0.6966,0 -1.26196,0.56536 -1.26196,1.26196c0,0.6966 0.56536,1.26196 1.26196,1.26196l20.19141,0c0.6966,0 1.26196,-0.56536 1.26196,-1.26196c0,-0.6966 -0.56536,-1.26196 -1.26196,-1.26196l-20.19141,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerDeparture);
export default __webpack_public_path__ + "static/media/marker-departure.b15ef6fbfb300ab41783f75bf8c0b3c3.svg";
export { ForwardRef as ReactComponent };